<template>
  <div>
    <div class="inner-content">
      <div class="container">
        <section class="product">
          <h2 class="wow animate fadeInDown">Color your hair the natural way</h2>
          <p class="wow animate fadeInUp">Solutions for quick hair coloring</p>

          <div class="container mt-40">
            <div class="row mt-30">
              <div
                class="col-md-4 col-sm-6"
                v-for="item in $root.products"
                :key="item.id"
                @click.prevent="showProduct(item)"
              >
                <div class="box14">
                  <img :src="item.images[0].src" alt>
                  <h4>{{item.extra_data.display_name}}</h4>
                  <p>{{item.extra_data.subtitle}}</p>
                  <div class="box-content">
                    <div class="post">
                      <img class="finder" src="../assets/images/icon-finder.svg">
                      <p v-html="item.short_description.substring(0,250)"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <footer2></footer2>
  </div>
</template>

<script>
import Footer2 from "@/components/Footer2.vue";
export default {
  name: "Products",
  components: {
    Footer2
  },
  mounted() {
    this.$root.initBody();
    //remove all touch events
    var myElement = document.getElementById("app");
    var mc = new Hammer(myElement);
    mc.destroy();
  },
  methods: {
    showProduct(item) {
      this.$router.push({
        name: "product-details",
        params: { productId: item.id }
      });
    }
  }
};
</script>


<style lang="stylus">
</style>
